import { LICENSE_OPTIONS } from "@constants/license";

export const getLicenseByStripeLookupKey = (key) => LICENSE_OPTIONS.find((plan) => plan.stripeLookupKey === key);

export const getStripeLookupById = (id) => LICENSE_OPTIONS.find((option) => option.id === id)?.stripeLookupKey;
